import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Constants } from '../../../constants/constants';
import { DenyDialogOutput } from '../../../models/DialogData';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-deny-dialog',
  templateUrl: './deny.dialog.component.html',
  styleUrls: ['./deny-dialog.component.scss'],
  imports:[
    MatButtonModule,
    MatDialogActions, 
    MatDialogClose, 
    MatDialogTitle, 
    MatDialogContent, 
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    TranslatePipe
  ]
})
export class DenyDialogComponent {

    denySection = new FormControl<string>(Constants.EMPTY_STRING);
  constructor(public dialogRef: MatDialogRef<DenyDialogComponent>,
    ) { 
    }

  DismissClick() {
    let data = new DenyDialogOutput();
    data.button = Constants.CANCEL;
    this.dialogRef.close(data);
  }

  OnConfirmClick() {
    let data = new DenyDialogOutput();
    data.button = Constants.OK
    data.comments = this.denySection.value ?? Constants.EMPTY_STRING;
    this.dialogRef.close(data);
  }
}
